/**
 * The /stock search params and their guard.
 *
 * They live apart from the page on purpose: `validateSearch` runs in the route
 * module, which the router loads eagerly, and importing the parser from the page
 * would pull the whole matrix — table, panel, core helpers — into the initial
 * bundle instead of its own lazy chunk.
 */
import { STOCK_MATRIX_VIEWS, type StockMatrixView } from '@aslen/core';

export const PANEL_TABS = ['genel', 'stok', 'maliyet', 'hareketler'] as const;
export type PanelTab = (typeof PANEL_TABS)[number];

export interface StockMatrixSearch {
  view?: StockMatrixView;
  /** csv of `items.type` */
  type?: string;
  size?: string;
  colour?: string;
  /** the selected item (C39: the web addresses items by id) */
  item?: string;
  expanded?: string;
  tab?: PanelTab;
  sort?: string;
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export function parseStockMatrixSearch(s: Record<string, unknown>): StockMatrixSearch {
  return {
    view: (STOCK_MATRIX_VIEWS as readonly string[]).includes(s.view as string) ? (s.view as StockMatrixView) : undefined,
    type: str(s.type),
    size: str(s.size),
    colour: str(s.colour),
    item: str(s.item),
    expanded: str(s.expanded),
    tab: (PANEL_TABS as readonly string[]).includes(s.tab as string) ? (s.tab as PanelTab) : undefined,
    sort: str(s.sort),
  };
}
